import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';

import { LoginService } from './../../../services/login.service';

import { MustMatch } from './../../../helpers/must-match.validator';

@Component({
  selector: 'app-cadastro',
  templateUrl: './cadastro.component.html',
  styleUrls: ['./cadastro.component.scss']
})
export class CadastroComponent implements OnInit {
  public form;
  isento: boolean = false;

  @ViewChild('cepValidFocus') cepValidFocus: ElementRef;
  @ViewChild('cepInvalidFocus') cepInvalidFocus: ElementRef;

  @ViewChild('cnpjValidFocus') cnpjValidFocus: ElementRef;
  @ViewChild('cnpjInvalidFocus') cnpjInvalidFocus: ElementRef;

  constructor(
    private fb: FormBuilder,
    private _location: Location,
    private _toastr: ToastrService,
    private _login: LoginService
  ) {
    this.form = fb.group({
      cnpj: ['', Validators.required],
      razao: ['', Validators.required],
      ie: ['', Validators.required],
      isento: [''],
      cep: ['', Validators.required],
      rua: ['', Validators.required],
      numero: ['', Validators.required],
      complemento: [''],
      bairro: ['', Validators.required],
      cidade: ['', Validators.required],
      estado: ['', Validators.required],
      pais: ['', Validators.required],
      nome: ['', Validators.required],
      sobrenome: ['', Validators.required],
      email: ['', Validators.required],
      ddd1: ['', Validators.required],
      telefone1: ['', Validators.required],
      ddd2: ['', Validators.required],
      telefone2: ['', Validators.required],
      senha: ['', Validators.required],
      csenha: ['', Validators.required]
    }, {
      validator: MustMatch('senha', 'csenha')
    });
  }

  ngOnInit() {
  }

  goBack() {
    this._location.back();
  }

  toggleIsento() {
    this.isento = !this.isento;
    const ie = this.form.get('ie');
    if (this.isento) {
      ie.setValidators(null);
      ie.disable();
    } else {
      ie.setValidators([Validators.required]);
      ie.enable();
    }
    ie.updateValueAndValidity();
  }

  cnpjValidade(cnpjValue: string) {
    let cnpjNum:string = cnpjValue.substr(0, 12),
      cnpjDigit:string = cnpjValue.substr(12, 2),
      cnpjCalc:number = 0;
    for (let count:number = 0; 12 > count; count++) {
      cnpjCalc += Number(cnpjNum.charAt(11 - count)) * (2 + (count % 8));
    }
    if (0 == cnpjCalc) {
      return false;
    }
    cnpjCalc = 11 - (cnpjCalc % 11);
    9 < cnpjCalc && (cnpjCalc = 0);
    if (Number(cnpjDigit.charAt(0)) != cnpjCalc) {
      return false;
    }
    cnpjCalc *= 2;
    for (let count:number = 0; 12 > count; count++) {
      cnpjCalc += Number(cnpjNum.charAt(11 - count)) * (2 + ((count + 1) % 8));
    }
    cnpjCalc = 11 - (cnpjCalc % 11);
    9 < cnpjCalc && (cnpjCalc = 0);
    return Number(cnpjDigit.charAt(1)) != cnpjCalc ? false : true;
  }

  onCnpjChange(cnpjValue: string) {
    if (cnpjValue.length == 14) {
      const validate = this.cnpjValidade(cnpjValue);
      if (validate) {
        this.cnpjValidFocus.nativeElement.focus();
      } else {
        this._toastr.error('CNPJ Digitado é inválido. Por favor, digite novamente.');
        const cnpj = this.form.get('cnpj');
        cnpj.setValue('');
        cnpj.updateValueAndValidity();
        this.cnpjInvalidFocus.nativeElement.focus();
      }
    }
  }

  onCepChange(cepValue: string) {
    if (cepValue.length == 9) {
      this._login.cep(cepValue).subscribe( response => {
        if (response !== null) {
          const rua = this.form.get('rua');
          const bairro = this.form.get('bairro');
          const cidade = this.form.get('cidade');
          const estado = this.form.get('estado');
          const pais = this.form.get('pais');
          rua.setValue(response.RUA);
          bairro.setValue(response.BAIRRO);
          cidade.setValue(response.CIDADE);
          estado.setValue(response.ESTADO);
          pais.setValue('Brasil');
          rua.disable();
          bairro.disable();
          cidade.disable();
          estado.disable();
          pais.disable();
          rua.updateValueAndValidity();
          bairro.updateValueAndValidity();
          cidade.updateValueAndValidity();
          estado.updateValueAndValidity();
          pais.updateValueAndValidity();
          this.cepValidFocus.nativeElement.focus();
        } else {
          this._toastr.error('CEP Digitado não encontrado. Por favor, digite novamente.');
          const cep = this.form.get('cep');
          cep.setValue('');
          cep.updateValueAndValidity();
          this.cepInvalidFocus.nativeElement.focus();
        }
      })
    } else {
      const rua = this.form.get('rua');
      const bairro = this.form.get('bairro');
      const cidade = this.form.get('cidade');
      const estado = this.form.get('estado');
      const pais = this.form.get('pais');
      rua.setValue('');
      bairro.setValue('');
      cidade.setValue('');
      estado.setValue('');
      pais.setValue('');
      rua.enable();
      bairro.enable();
      cidade.enable();
      estado.enable();
      pais.enable();
      rua.updateValueAndValidity();
      bairro.updateValueAndValidity();
      cidade.updateValueAndValidity();
      estado.updateValueAndValidity();
      pais.updateValueAndValidity();
    }
  }

  cadastrarCliente() {
    if (this.form.valid) {
      this._toastr.success('Envia form.');
      // this._login.cadastroCliente()
    } else {
      this._toastr.error('Form com erro.');
    }
  }

}
